export default __webpack_public_path__ + "static/media/notification.29862434.svg";